export default __webpack_public_path__ + "static/media/magnifying-glass.b7381f78.png";